import { Box, Card, CardContent, Typography } from '@mui/material'

export default function ServicesPage() {
    return (
        <Box>
            <Typography variant="h5" sx={{ fontWeight: 600, mb: 3 }}>Services</Typography>
            <Card>
                <CardContent sx={{ p: 4, textAlign: 'center' }}>
                    <Typography variant="body1" sx={{ color: 'grey.500' }}>
                        Manage solar installation and maintenance services offered by Starwave Energy.
                    </Typography>
                </CardContent>
            </Card>
        </Box>
    )
}
